import { ConfigProvider, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

// onChange = (checked) => {}  //checked is current state

const MySwitch = (props) => {
    const { 
        // defaultChecked=false,
        value,
        onChange, className, ...rest } = props;

        // console.log(value, " = selectedddddddd");
  return (
    <ConfigProvider

        theme={{
            token: {
                colorPrimary: '#FF8536',
                colorPrimaryHover: '#E3302E',
            },
        }}
        >
            <Switch
                // className={`custom-switch ${className}`}
                // checkedChildren={<CheckOutlined />}
                // unCheckedChildren={<CloseOutlined />}
                // defaultChecked={defaultChecked}
                // defaultChecked={selected}
                checked={value}
                onChange={onChange}
                {...rest}
            />
        </ConfigProvider>
    );
}

export default MySwitch